export function authHeader() {
  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };
  // return authorization header with jwt token
  let account = JSON.parse(localStorage.getItem("account"));

  if (account && account.jwt) {
    headers["Authorization"] = "Bearer " + account.jwt;
  }

  return headers;

  // return {
  //   headers
  // };
}
